import type {
  ProductSize,
  SizeDimension,
  SizeDimension_SingleDimensionSize,
  SizeDimension_TwoDimensionSize,
  SizeDimension_BraSize,
  SizeDimension_PantsSize,
} from "../../aysa_api/models/product_size.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  encodeSizePrice,
  encodeLowestPriorPriceHint,
  decodeSizePrice,
  decodeLowestPriorPriceHint,
} from "../../aysa_api/models/product_price";
import type { Long } from "protoc-gen-ts";

export const createBaseProductSize = (): ProductSize => {
  return {
    id: 0,
    quantity: 0,

    vendorSize: createBaseSizeDimension(),

    articleNumber: "",

    supplierId: 0,
  };
};

export const decodeProductSize = (
  reader: Reader,
  length: number
): ProductSize => {
  const end = reader.pos + length;
  const message = createBaseProductSize();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.quantity = (reader.int64() as Long).toNumber();

        break;
      case 3:
        message.price = decodeSizePrice(reader, reader.uint32());

        break;
      case 4:
        message.vendorSize = decodeSizeDimension(reader, reader.uint32());

        break;
      case 5:
        message.shopSize = decodeSizeDimension(reader, reader.uint32());

        break;
      case 7:
        message.articleNumber = reader.string();

        break;
      case 8:
        message.lowestPriorPriceHint = decodeLowestPriorPriceHint(
          reader,
          reader.uint32()
        );

        break;
      case 9:
        message.supplierId = (reader.int64() as Long).toNumber();

        break;
      case 10:
        message.lowStockHint = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductSize = (
  writer: Writer,
  message: ProductSize
): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(16).int64(message.quantity);
  if (message.price !== undefined) {
    encodeSizePrice(writer.uint32(26).fork(), message.price).ldelim();
  }
  encodeSizeDimension(writer.uint32(34).fork(), message.vendorSize).ldelim();
  if (message.shopSize !== undefined) {
    encodeSizeDimension(writer.uint32(42).fork(), message.shopSize).ldelim();
  }
  writer.uint32(58).string(message.articleNumber);
  if (message.lowestPriorPriceHint !== undefined) {
    encodeLowestPriorPriceHint(
      writer.uint32(66).fork(),
      message.lowestPriorPriceHint
    ).ldelim();
  }
  writer.uint32(72).int64(message.supplierId);
  if (message.lowStockHint !== undefined) {
    writer.uint32(82).string(message.lowStockHint);
  }

  return writer;
};

export const createBaseSizeDimension = (): SizeDimension => {
  return {};
};

export const decodeSizeDimension = (
  reader: Reader,
  length: number
): SizeDimension => {
  const end = reader.pos + length;
  const message = createBaseSizeDimension();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.size = {
          $case: "singleDimension",
          singleDimension: decodeSizeDimension_SingleDimensionSize(
            reader,
            reader.uint32()
          ),
        };

        break;
      case 2:
        message.size = {
          $case: "twoDimension",
          twoDimension: decodeSizeDimension_TwoDimensionSize(
            reader,
            reader.uint32()
          ),
        };

        break;
      case 3:
        message.size = {
          $case: "bra",
          bra: decodeSizeDimension_BraSize(reader, reader.uint32()),
        };

        break;
      case 4:
        message.size = {
          $case: "pants",
          pants: decodeSizeDimension_PantsSize(reader, reader.uint32()),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSizeDimension = (
  writer: Writer,
  message: SizeDimension
): Writer => {
  if (message.size !== undefined) {
    switch (message.size.$case) {
      case "singleDimension":
        encodeSizeDimension_SingleDimensionSize(
          writer.uint32(10).fork(),
          message.size.singleDimension
        ).ldelim();

        break;
      case "twoDimension":
        encodeSizeDimension_TwoDimensionSize(
          writer.uint32(18).fork(),
          message.size.twoDimension
        ).ldelim();

        break;
      case "bra":
        encodeSizeDimension_BraSize(
          writer.uint32(26).fork(),
          message.size.bra
        ).ldelim();

        break;
      case "pants":
        encodeSizeDimension_PantsSize(
          writer.uint32(34).fork(),
          message.size.pants
        ).ldelim();

        break;
    }
  }
  return writer;
};

export const createBaseSizeDimension_SingleDimensionSize =
  (): SizeDimension_SingleDimensionSize => {
    return {
      dimension: "",
    };
  };

export const decodeSizeDimension_SingleDimensionSize = (
  reader: Reader,
  length: number
): SizeDimension_SingleDimensionSize => {
  const end = reader.pos + length;
  const message = createBaseSizeDimension_SingleDimensionSize();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.dimension = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSizeDimension_SingleDimensionSize = (
  writer: Writer,
  message: SizeDimension_SingleDimensionSize
): Writer => {
  writer.uint32(10).string(message.dimension);

  return writer;
};

export const createBaseSizeDimension_TwoDimensionSize =
  (): SizeDimension_TwoDimensionSize => {
    return {
      firstDimension: "",
      secondDimension: "",
      label: "",
    };
  };

export const decodeSizeDimension_TwoDimensionSize = (
  reader: Reader,
  length: number
): SizeDimension_TwoDimensionSize => {
  const end = reader.pos + length;
  const message = createBaseSizeDimension_TwoDimensionSize();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.firstDimension = reader.string();

        break;
      case 2:
        message.secondDimension = reader.string();

        break;
      case 3:
        message.label = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSizeDimension_TwoDimensionSize = (
  writer: Writer,
  message: SizeDimension_TwoDimensionSize
): Writer => {
  writer.uint32(10).string(message.firstDimension);
  writer.uint32(18).string(message.secondDimension);
  writer.uint32(26).string(message.label);

  return writer;
};

export const createBaseSizeDimension_BraSize = (): SizeDimension_BraSize => {
  return {
    bandSize: "",
    cup: "",
    label: "",
  };
};

export const decodeSizeDimension_BraSize = (
  reader: Reader,
  length: number
): SizeDimension_BraSize => {
  const end = reader.pos + length;
  const message = createBaseSizeDimension_BraSize();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.bandSize = reader.string();

        break;
      case 2:
        message.cup = reader.string();

        break;
      case 3:
        message.label = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSizeDimension_BraSize = (
  writer: Writer,
  message: SizeDimension_BraSize
): Writer => {
  writer.uint32(10).string(message.bandSize);
  writer.uint32(18).string(message.cup);
  writer.uint32(26).string(message.label);

  return writer;
};

export const createBaseSizeDimension_PantsSize =
  (): SizeDimension_PantsSize => {
    return {
      width: "",
      length: "",
      label: "",
    };
  };

export const decodeSizeDimension_PantsSize = (
  reader: Reader,
  length: number
): SizeDimension_PantsSize => {
  const end = reader.pos + length;
  const message = createBaseSizeDimension_PantsSize();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.width = reader.string();

        break;
      case 2:
        message.length = reader.string();

        break;
      case 3:
        message.label = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeSizeDimension_PantsSize = (
  writer: Writer,
  message: SizeDimension_PantsSize
): Writer => {
  writer.uint32(10).string(message.width);
  writer.uint32(18).string(message.length);
  writer.uint32(26).string(message.label);

  return writer;
};
